import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ec9dc06"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "password-strength-meter-wrapper",
  style: {"position":"relative","width":"100%","margin":"5px 0px 1rem"},
  class: "mb-2"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"4px","background-color":"rgb(232, 232, 232)","width":"100%","position":"absolute","left":"0px"} }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"4px","width":"2px","background-color":"rgb(255, 255, 255)","position":"absolute","left":"25%"} }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"4px","width":"2px","background-color":"rgb(255, 255, 255)","position":"absolute","left":"50%"} }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"4px","width":"2px","background-color":"rgb(255, 255, 255)","position":"absolute","left":"75%"} }, null, -1))
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      id: "password-meter-strength",
      style: _normalizeStyle([_ctx.getWidth, {"height":"4px","position":"absolute","left":"0px"}]),
      class: _normalizeClass(_ctx.passwClass.bgMeterClass)
    }, null, 6),
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", {
      id: "password-meter-label",
      class: "pw-meter-lbl-norm",
      innerHTML: _ctx.passwClass.infoClass
    }, null, 8, _hoisted_6)
  ]))
}